import {
  Context,
  createContext,
  FC,
  useContext,
  useEffect,
  useState,
} from "react";
import { ISeoPage } from "../libs/seo-widget/types/types";

export interface ISeoContext {
  seoPage?: ISeoPage;
  setSeoPage?: (seoPage: ISeoPage) => void;
}

// Create Context

const SeoContext: Context<ISeoContext> = createContext({
  seoPage: undefined,
  setSeoPage: undefined,
});

export function useGetSeoPage(): ISeoPage {
  return useContext(SeoContext).seoPage || {};
}

export function useSeoPageContext(): ISeoContext {
  return useContext(SeoContext);
}

//FooterBlocks

export function useLink2() {
  const seoPage = useGetSeoPage();
  let { link2 = "" } = seoPage;
  const [link2State, setLink2State] = useState<string>(link2);
  useEffect(() => {
    if (window.location.search && !seoPage?.link2?.includes("?")) {
      link2 += window.location.search;
    }
    setLink2State(link2);
  }, [link2, JSON.stringify(seoPage)]);
  return link2State;
}

//
const SeoContextProvider: FC<ISeoContext> = (props) => {
  const { children, seoPage: seoPage__default } = props;
  const [seoPage, setSeoPage] = useState<ISeoPage>(seoPage__default);
  useEffect(() => {
    setSeoPage(seoPage__default);
  }, [seoPage__default]);
  useEffect(() => {
    if(!seoPage?.hrefLangs){
      document.querySelectorAll("head > link[hreflang]")?.forEach((it)=> it.remove())
    }
  }, [seoPage?.hrefLangs]);
  return (
    <SeoContext.Provider value={{ seoPage, setSeoPage }}>
      {children}
    </SeoContext.Provider>
  );
};

export default SeoContextProvider;
